import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=0dbb20a2&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=0dbb20a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbb20a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dbb20a2')) {
      api.createRecord('0dbb20a2', component.options)
    } else {
      api.reload('0dbb20a2', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=0dbb20a2&scoped=true&", function () {
      api.rerender('0dbb20a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/Dashboard.vue"
export default component.exports